import { render, staticRenderFns } from "./ArmGroup.vue?vue&type=template&id=2f586991&"
import script from "./ArmGroup.vue?vue&type=script&lang=js&"
export * from "./ArmGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports